module.exports = {"TXTWCL_Returns":{"id":"TXTWCL_Returns","defaultMessage":"Vincita"},"TXTWCL_n_a":{"id":"TXTWCL_n_a","defaultMessage":"n.a."}}